// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2S8yP","emails":"CreateEditClinics_emails__3YNCW","emailTagLabel":"CreateEditClinics_emailTagLabel__2ZSXV"};